import { gql } from "@apollo/client"

export const ORDER_UPDATE_METADATA = gql`
  mutation updateMetadata($orderId: ID!, $input: [MetadataInput!]!) {
    updateMetadata(id: $orderId, input: $input) {
      errors {
        field
        message
      }
    }
  }
`
